import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Hero } from '../components/home/Hero';
import { RealityCheck } from '../components/home/RealityCheck';
import { CaseStudies } from '../components/home/CaseStudies';
import { MidPageCTA } from '../components/home/MidPageCTA';
import { WhyLAI } from '../components/home/WhyLAI';
import { SystemsGrid } from '../components/home/SystemsGrid';
import { Process } from '../components/home/Process';
import { FAQ } from '../components/home/FAQ';
import { CTA } from '../components/home/CTA';
export function HomePage() {
  return <Layout data-id="element-422">
      <Hero data-id="element-423" />
      <RealityCheck data-id="element-424" />
      <CaseStudies data-id="element-425" />
      <MidPageCTA data-id="element-426" />
      {/* Moved WhyLAI higher - establish trust before diving into systems details */}
      <WhyLAI data-id="element-427" />
      <SystemsGrid data-id="element-428" />
      <Process data-id="element-429" />
      <FAQ data-id="element-430" />
      <CTA data-id="element-431" />
    </Layout>;
}